import axios from "axios";
import React, { useEffect, useState } from "react";
import { getCurrentFY } from "../../Utilitie";
import Loading from "../../Extra/Loading";
import CrewAvgFilter from "./CrewAvgFilter";
import NoDataFound from "../../Extra/NoDataFound";
import CrewAvgTable from "./CrewAvgTable";
import CrewAvgOccChart from "./CrewAvgOccChart";
import CrewAvgTimeChart from "./CrewAvgTimeChart";

const opState = {
  Year: false,
  Months: false,
  Lobby: false,
  Station: false,
};
const CrewAvgMaster = () => {
  const [selectedLineBar, setSelectedLineBar] = useState("");
  const [selectedBar, setSelectedBar] = useState([]);

  const addSelectedBar = (newObj) => {
    setSelectedBar((prev) => {
      // find dynamic key (lobby / month / station / etc.)
      const identityKey = Object.keys(newObj).find(
        (key) => key !== "barValue" && key !== "seriesName",
      );

      if (!identityKey) return prev;

      // remove all previous objects that contain the same key name
      const filtered = prev.filter((item) => !(identityKey in item));

      // add the new object
      return [...filtered, newObj];
    });
  };
  useEffect(() => {
    addSelectedBar(selectedLineBar);
  }, [selectedLineBar]);

  const urlPrefixBlock = process.env.REACT_APP_URL_CMS_PREFIX;
  const [avgData, setAvgData] = useState(null);
  const currentYear = getCurrentFY();
  const [year, setYear] = useState(currentYear.slice(0, 4));
  const years = Array.from(
    { length: 10 },
    (_, i) => new Date().getFullYear() - i,
  ); // last 10 years
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openStates, setOpenStates] = useState(opState);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}get_t_cms_avg_rest_2?Year_=${year}`,
      );

      setLoading(false);

      if (response.statusText === "OK") {
        const merged = [
          ...(response.data.current_data || []),
          ...(response.data.previous_data || []),
        ];

        setAvgData(merged.filter((row) => row.Lobby !== "[TOTAL]"));
      }
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [year]);
  const selectedBarData = filteredData?.filter((o) => {
    if (selectedLineBar.barName) {
      return o.Lobby === selectedLineBar.barName;
    } else {
      return true;
    }
  });

  return (
    <div onClick={() => setOpenStates(opState)}>
      <div className=" bg-dark text-white ps-2 p-1 d-flex align-items-center justify-content-between ">
        <div>
          <h5 className="">HQ Crew Rest At Outstation{}</h5>
        </div>
        <div className="row pe-3 d-flex align-items-center">
          <b className="col-md text-end" style={{ fontSize: "18px" }}>
            Year
          </b>
          <div className="col-md">
            <select
              style={{ width: "100px", height: "35px" }}
              className="form-select"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="">--FY-- </option>
              {years.map((yr, i) => (
                <option key={yr} value={yr}>
                  {yr}-{String(yr + 1).slice(2, 4)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {loading && <Loading />}
      <>
        {loading && <Loading />}

        {avgData && (
          <div className="sticky-controller">
            <CrewAvgFilter
              data={avgData}
              setSelectedFilters={setSelectedFilters}
              setFilteredData={setFilteredData}
              openStates={openStates}
              setOpenStates={setOpenStates}
            />
          </div>
        )}
        {filteredData?.length > 0 || <NoDataFound />}
        <div className="row">
          <div className=" col-md-6">
            {filteredData?.length > 0 && (
              <CrewAvgOccChart
                data={filteredData}
                setSelectedLineBar={setSelectedLineBar}
              />
            )}
          </div>
          <div className="col-md-6">
            {filteredData?.length > 0 && (
              <CrewAvgTimeChart
                data={selectedBarData}
                setSelectedLineBar={setSelectedLineBar}
              />
            )}
          </div>
        </div>
        {filteredData?.length > 0 && (
          <CrewAvgTable
            data={selectedBarData}
            selectedLineBar={selectedLineBar}
          />
        )}
      </>
    </div>
  );
};

export default CrewAvgMaster;
